export class MemberBasicsItem {
    ID: number;
    Name: string;
    IsDesigner: boolean;
}

export class MemberBasicsItemArray extends Array<MemberBasicsItem> {

    constructor(...items: MemberBasicsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberBasicsItemArray.prototype);
    }

}
